class NewHeroSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.new-hero-slider');
    if (!swiperEl) return;

    // Initialize Swiper
    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        speed: 800,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        // autoplay: {
        //   delay: 5500,
        //   disableOnInteraction: false,
        //   pauseOnMouseEnter: true
        // }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('new-hero-slider', NewHeroSlider);